import React from 'react';
import './SnippetArea.css';
import { between } from '../../utils/customutils';

export default function SnippetArea({ example, onLoadCodeExample }) {
  if (!example) return null;

  // Parse the example code
  const codeContent = between(example, "{{", "}}");
  const [before, after] = example.split(codeContent);
  const beforeCode = before ? before.replace("{{", "") : '';
  const code = codeContent;
  const afterCode = after ? after.replace("}}", "") : '';

  // Process comments and result lines
  const getLineStyle = (line) => {
    if (line.trim().startsWith('//')) return 'text-emerald-400 italic';
    if (line.toLowerCase().includes('resultado:')) return 'text-purple-400 font-semibold';
    return '';
  };

  const formatLines = (text) => {
    if (!text) return [];
    return text.split('\n').map((line, i) => (
      <div key={i} className={`py-0.5 ${getLineStyle(line)}`}>
        {line}
      </div>
    ));
  };

  return (
    <div className="overflow-hidden rounded-xl border border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-900 shadow-sm hover:shadow-md transition-shadow duration-200">
      {/* Editor Header */}
      <div className="flex items-center justify-between px-5 py-3 bg-gray-100 dark:bg-gray-800/90 border-b border-gray-200 dark:border-gray-700">
        <div className="flex items-center gap-3">
          <div className="flex space-x-2">
            <div className="w-3 h-3 rounded-full bg-red-500 shadow-inner"></div>
            <div className="w-3 h-3 rounded-full bg-yellow-500 shadow-inner"></div>
            <div className="w-3 h-3 rounded-full bg-green-500 shadow-inner"></div>
          </div>
          <span className="text-xs font-medium text-gray-500 dark:text-gray-400 tracking-wide uppercase">Ejemplo</span>
        </div>
        <div className="flex items-center gap-2 text-gray-400">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-4 h-4">
            <path fillRule="evenodd" d="M4.25 2A2.25 2.25 0 002 4.25v11.5A2.25 2.25 0 004.25 18h11.5A2.25 2.25 0 0018 15.75V4.25A2.25 2.25 0 0015.75 2H4.25zm4.03 6.28a.75.75 0 00-1.06-1.06L4.97 9.47a.75.75 0 000 1.06l2.25 2.25a.75.75 0 001.06-1.06L6.56 10l1.72-1.72zm4.5-1.06a.75.75 0 10-1.06 1.06L13.44 10l-1.72 1.72a.75.75 0 101.06 1.06l2.25-2.25a.75.75 0 000-1.06l-2.25-2.25z" clipRule="evenodd" />
          </svg>
        </div>
        {/* Code Example - BACK ON TOP */}



      </div>

      {/* Editor Content */}
      <div className="p-5 font-mono text-sm overflow-x-auto bg-white dark:bg-gray-900/50">
        {/* Comments and initialization */}
        {beforeCode && (
          <div className="space-y-0.5 mb-4">
            {formatLines(beforeCode)}
          </div>
        )}

        {/* The actual code expression */}
        {code && (
          <div className="relative my-4 group">
            <div className="absolute -left-5 top-0 bottom-0 w-1 bg-blue-500 rounded-full"></div>
            <div className="px-4 py-3 bg-blue-50 dark:bg-blue-900/20 text-blue-700 dark:text-blue-300 rounded-r-lg border-r border-t border-b border-blue-200 dark:border-blue-800">
              <div className="font-semibold">{code}</div>
            </div>
          </div>
        )}

        {/* The result or additional comments */}
        {afterCode && (
          <div className="space-y-0.5 mt-4">
            {formatLines(afterCode)}
          </div>
        )}
      </div>
    </div>
  );
}
